import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, SmallCheckBox } from '@piplapps/pipl-ui';
import styles from './LeadVettingFormStyles.module.less';
import Enums from '../../../Constants/Enums';
import AppConfig from '../../../Config/AppConfig';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import PageviewHandler from '../../../Utils/AnalyticsHandler/PageviewHandler';
import TermsOfServiceTrialText from '../../SignUpPage/components/TermsOfServiceTrialText';

const VettingTerms = (props) => {
  const { isLoading } = props;
  const [checked, setCheck] = useState(false);

  const titleGenerator = (product) => {
    if (product === Enums.PRODUCT_TYPE.SEARCH_TRIAL) {
      return `Thanks for your interest in a Pipl Subscription ${AppConfig.SEF_PRO_TRIAL_DAYS || '5'}-day trial!`;
    }
    if (product === Enums.PRODUCT_TYPE.API_TRIAL) {
      return `Thanks for your interest in a Pipl API trial!`;
    }
    if (product === Enums.PRODUCT_TYPE.SEARCH_PURCHASE) {
      return `Thanks for your interest in a Pipl Subscription!`;
    }
    if (product === Enums.PRODUCT_TYPE.API_PURCHASE) {
      return `Thanks for your interest in a Pipl API!`;
    }
    return '';
  };

  const productMap = {
    SEARCH_TRIAL: 'SEARCH',
    SEARCH_PURCHASE: 'SEARCH',
    API_TRIAL: 'API',
    API_PURCHASE: 'API',
  };

  return (
    <div>
      <PageviewHandler path="vetting-terms/" />
      <div className={styles.headerWrapper}>
        <div className={[styles.pageTitle, styles.formWrapper, styles.titleWrap].join(' ')}>
          <span>{gettext(titleGenerator(props.product))}</span>
        </div>
        <div className={[styles.pageTitle, styles.subTitle].join(' ')}>
          <span>{gettext('Before we take the next step, it’s important to read this section carefully.')}</span>
        </div>
      </div>
      <div className={styles.greyBox}>
        <TermsOfServiceTrialText />
        <div className={styles.termsLine}>
          <SmallCheckBox onChange={() => setCheck(!checked)} checked={checked} label={gettext('I agree')} />
        </div>
      </div>
      <AnalyticsHandler eventName={AnalyticsEventNames.ACCEPT_TERMS}>
        <div className={styles.proceedButton}>
          <Button
            id="submit-button"
            buttonClass="primary-green"
            type="submit"
            text={gettext('Proceed')}
            isLoading={isLoading}
            loadingText={gettext('Saving')}
            disabled={document.cookie.indexOf('automation_tests') > -1 ? false : !checked}
            onClick={() => props.onSubmit()}
          />
        </div>
      </AnalyticsHandler>
    </div>
  );
};
VettingTerms.propTypes = {
  isLoading: PropTypes.bool,
  onSubmit: PropTypes.func,
  product: PropTypes.string,
};

export default VettingTerms;
